// Hợp đồng API của module `push` — thông báo đẩy về thiết bị (Web Push, 03/10/2026).
import { z } from 'zod';
/**
 * Đăng ký nhận thông báo của MỘT thiết bị — đúng thứ `PushSubscription.toJSON()` của trình duyệt trả
 * về. `p256dh` là khoá công khai của thiết bị (65 byte), `auth` là bí mật xác thực (16 byte), cả hai ở
 * dạng base64url.
 */
export const pushSubscriptionSchema = z.object({
    endpoint: z.string().url().max(2000),
    keys: z.object({
        p256dh: z
            .string()
            .min(80)
            .max(200)
            .regex(/^[A-Za-z0-9_-]+=*$/),
        auth: z
            .string()
            .min(16)
            .max(64)
            .regex(/^[A-Za-z0-9_-]+=*$/),
    }),
});
export const pushUnsubscribeSchema = z.object({ endpoint: z.string().min(1).max(2000) });
//# sourceMappingURL=push.js.map